import { render, staticRenderFns } from "./record-info.vue?vue&type=template&id=9c418026&scoped=true"
import script from "./record-info.vue?vue&type=script&lang=js"
export * from "./record-info.vue?vue&type=script&lang=js"
import style0 from "./record-info.vue?vue&type=style&index=0&id=9c418026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c418026",
  null
  
)

export default component.exports